import { createPaginatedSlice } from "../../../helpers/reduxHelper";

const configuratorLighting = createPaginatedSlice('configuratorLighting');

export const configuratorLightingActions = configuratorLighting.actions
export const configuratorLightingSelector = state => state.configuratorLighting;
export const configuratorLightingReducer = configuratorLighting.reducer;
export default configuratorLightingReducer

export const configuratorLightingSelectors = configuratorLighting.LF.selectors